/**
 * 缓存池
 */
export class CachePool<T> {
  private list: T[] = [];

  /**
   * 获取缓存池数据
   */
  getPool(): T[] {
    return this.list;
  }

  /**
   * 向list中添加元素
   */
  add(item: T): number {
    return this.list.push(item);
  }

  /**
   * 删除list中指定元素
   */
  remove(item: T): T | undefined {
    const index = this.list.findIndex((val) => val === item);
    if (index !== -1) {
      return this.list.splice(index, 1)[0];
    }
  }

  /**
   * 清空list
   */
  removeAll() {
    this.list.length = 0;
  }

  /**
   * 获取list大小
   */
  size(): number {
    return this.list.length;
  }

  /**
   * 移除最后一个元素
   */
  pop(): T | undefined {
    return this.list.pop();
  }

  /**
   * 移除第一个元素
   */
  shift(): T | undefined {
    return this.list.shift();
  }

  /**
   * 判断当前缓存池是否为空
   */
  isEmpty(): boolean {
    return this.size() === 0;
  }
}
